<div style="padding: 24px;text-align: center;background-color: #161616;">
  <div style="font-size:18px;font-weight:600;color: #DEDEDE;">Are you sure?</div>
  <div style="margin-top:8px;margin-bottom:16px;color: rgba(255, 255, 255, 0.4);font-size:14px">You will lose all information about the floorplan. Are you sure you want to delete this
    floorplan?</div>
  <div style="display: flex; justify-content: center">
    <button mat-button (click)="cancel()" style="background: #161616; color: #DEDEDE;border-radius: 8px;margin-right: 10px;width: 162px;height: 52px;border: 1px solid #DEDEDE;">Back</button>
    <button mat-button (click)="confirm()" style="background: #161616; color: #DEDEDE;border-radius: 8px;width: 162px;height: 52px;border: 1px solid #DEDEDE;">Confirm</button>
  </div>
</div>